// setup axios-cancel module
// allows auto cancel previous request by sending "requestId" in axios config
import axios from 'axios';
import axiosCancel from 'axios-cancel';
axiosCancel(axios);

const tokenUrl = '/umbraco/surface/authenticationapi/antiforgerytoken';
let tokenRequest = null;

// Pages served from the edge cache carry no token (AntiForgeryViewComponent), so one is fetched
// before the first request that is validated against it. Every validated endpoint is a POST.
const ensureToken = () => {
  if (window.__RequestVerificationToken) {
    return Promise.resolve();
  }

  if (!tokenRequest) {
    tokenRequest = axios
      .get(tokenUrl)
      .then(response => {
        window.__RequestVerificationToken = response.data;
      })
      .catch(error => console.warn('Failed to fetch antiforgery token:', error))
      .finally(() => {
        tokenRequest = null;
      });
  }

  return tokenRequest;
};

// add csrf token to requests
axios.interceptors.request.use(async config => {
  if ((config.method || 'get').toLowerCase() !== 'get') {
    await ensureToken();
  }

  config.headers.csrfToken = window.__RequestVerificationToken;
  return config;
});
